export const SERVICES_FETCH = 'SERVICES_FETCH'
export const SERVICES_FETCH_SUCCESS = 'SERVICES_FETCH_SUCCESS'
export const SERVICES_FETCH_FAILURE = 'SERVICES_FETCH_FAILURE'

export const CITATIONS_FETCH = 'CITATIONS_FETCH'
export const CITATIONS_FETCH_SUCCESS = 'CITATIONS_FETCH_SUCCESS'
export const CITATIONS_FETCH_FAILURE = 'CITATIONS_FETCH_FAILURE'

export const SERVICES_AND_CITATIONS_FETCH_CANCEL = 'SERVICES_AND_CITATIONS_FETCH_CANCEL'

export const SERVER_NOT_RESPONDING = 'SERVER_NOT_RESPONDING'

export const SET_COLLECTION = 'SET_COLLECTION'

export const REPORT_PAGE_CHANGE_VISIBILITY = 'REPORT_PAGE_CHANGE_VISIBILITY'

export const GENERATE_FILE = 'GENERATE_FILE'



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js